import { render, staticRenderFns } from "./AdminOrdersHistory.vue?vue&type=template&id=7288e1d0&scoped=true&"
import script from "./AdminOrdersHistory.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrdersHistory.vue?vue&type=style&index=0&id=7288e1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288e1d0",
  null
  
)

export default component.exports